$(function () {
  if (!customElements.get('header-not-login')) {
    customElements.define(
      'header-not-login',
      class drawerLogin extends HTMLElement {
        constructor() {
          super();
          this.$drawerLogin = null;
          this.$body = null;
          this.currentType = 'login';
          this.container = null;
          this.rsa = null;
          this.timer = null;
          this.urlParams = null;
          this.sign = null;
          this.mobileType = new Set();
          this.status = false;
          window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
          this.modalManager = window.litime.ModalControllerState;
          this.source = 2;
          this.asyncEmail = null;
          this.referralInviterCode = null;
          this.marketingCampaignId = null;
        }

        connectedCallback() {
          const _this = this;
          this.$body = $('body');
          this.init();
          this.drawerInit();
          // 获取地址栏参数
          this.urlParams = new URLSearchParams(window.location.search);
          const type = this.urlParams.get('type');
          if (type && type === 'reset') {
            setTimeout(() => {
              this.initModal(false);
              setTimeout(() => {
                // 重置密码
                this.changeType('reset-password');
                const account = this.urlParams.get('email');
                if (this.container) {
                  const resetPart = this.container.querySelector('[data-header-type="reset-password"]');
                  const emailInput = resetPart.querySelector('input[name="email"]');
                  emailInput.value = account;
                  const emailInputParent = emailInput.closest('.input_text_container');
                  emailInputParent.setAttribute('data-has-value', 'true');
                }
              }, 10);
            }, 100);
          }

          if (type && type === 'setup') {
            this.verifySetupSign({
              sign: this.urlParams.get('sign'),
            })
              .then((res) => {
                setTimeout(() => {
                  this.initModal(false);
                  if (res.code === 10051110) return;
                  setTimeout(() => {
                    // 设置密码
                    this.changeType('setup-password');
                    const account = this.urlParams.get('email');
                    if (this.container) {
                      const setupPart = this.container.querySelector('[data-header-type="setup-password"]');
                      const emailInput = setupPart.querySelector('input[name="email"]');
                      emailInput.value = account;
                      const emailInputParent = emailInput.closest('.input_text_container');
                      emailInputParent.setAttribute('data-has-value', 'true');
                    }
                  }, 10);
                }, 100);
              })
              .catch((error) => {
                this.initModal(false);
                setTimeout(() => {
                  this.changeType('sign-expired');
                  if (this.container) {
                    const signExpiredPart = this.container.querySelector('[data-header-type="sign-expired"]');
                    const signExpiredDescription = signExpiredPart.querySelector('.sign-expired-description');
                    signExpiredDescription.addEventListener('click', () => {
                      window.litime.openChatApp();
                    });
                  }
                }, 0);
              });
          }
          // 订阅登录事件
          this.unsubscribeLogin = window.litime.eventBus.subscribe('CLOSE_DRAWER', () => {
            this.modalManager.close('drawer-login');
          });

          // 订阅忘记密码事件
          this.unsubscribeForgotPassword = window.litime.eventBus.subscribe('FORGOT_PASSWORD', () => {
            this.initModal(false);
            setTimeout(() => {
              this.changeType('forgot-password');
            }, 0);
          });

          // 订阅强制修改密码事件
          this.unsubscribeChangePassword = window.litime.eventBus.subscribe('CHANGE_PASSWORD', (data) => {
            this.sign = data.sign;
            this.asyncEmail = data.email;
            this.rsa = data.rsa;

            setTimeout(() => {
              this.initModal(false);
              setTimeout(() => {
                this.changeType('async-password');
              }, 10);
            }, 50);
          });

          // 订阅注册成功事件
          this.unsubscribeRegister = window.litime.eventBus.subscribe('REGISTER_SUCCESS', (data) => {
            setTimeout(() => {
              this.initModal(false);
              setTimeout(() => {
                const registerPart = this.container.querySelector('[data-header-type="register"]');
                const $formDom = $(registerPart.querySelector('form'));
                const $emailInput = $formDom.find('input[name="email"]');
                $emailInput.val(data.email);
                const $passwordInput = $formDom.find('input[name="password"]');
                $passwordInput.val(data.password);

                this.changeType('verify');
                const $verifyPart = $(this.container.querySelector('[data-header-type="verify"]'));
                const $verifyDescription = $verifyPart.find('.verify-description');
                const description = $verifyDescription.text();
                const emailHighlight = `<span class="text-primary">${data.email}</span>`;
                const newDescription = description
                  .replace('{{email}}', emailHighlight)
                  .replace('{{ email }}', emailHighlight);
                $verifyDescription.html(newDescription);
                window.litime.showToast('success', window.i18n.send_code_success);
              }, 10);
            }, 10);
          });

          // 订阅登录事件
          this.unsubscribeLogin = window.litime.eventBus.subscribe('LOGIN', (data) => {
            this.initModal();
            this.source = 3;
            // CollectionLottery活动渠道注册
            if (data && data.source === 'CollectionLottery') {
              this.source = 11;
              this.marketingCampaignId = data.marketingCampaignId;
            }
          });
          // 订阅注册事件
          this.unsubscribeRegister = window.litime.eventBus.subscribe('REGISTER', (data) => {
            setTimeout(() => {
              this.initModal(false);
              setTimeout(() => {
                this.changeType('register');
                this.source = 3;
                this.referralInviterCode = data.referralInviterCode;
              }, 100);
            }, 10);
          });
        }
        disconnectedCallback() {}
        init() {
          const _this = $(this);
          const $inputDom = _this.find('.input_text');
          const $formDom = _this.find('form');
          const $submitButton = _this.find('.login-submit');
          let emailValid = '';
          let passwordValid = '';
          $submitButton.on('click', (event) => {
            event.preventDefault();
            $inputDom.parents('.input_text_container').each(function () {
              const input_text = $(this).find('.input_text').val(); // 获取当前输入框的值

              const rule = $(this).data('rule'); // 获取当前规则

              if (rule) {
                if (rule === 'email' && ltUtils.rule.email.test(input_text)) {
                  emailValid = ltUtils.rule.email.test(input_text);
                } else if (rule === 'password' && ltUtils.rule.password.test(input_text)) {
                  passwordValid = ltUtils.rule.password.test(input_text);
                } else {
                  isValid = false; // 如果验证不通过，设置为无效
                  $(this).attr('data-error', 'true'); // 设置错误标志
                }
              }

              if (emailValid && passwordValid) {
                $formDom.submit(); // 如果两个条件都满足，提交表单
              }
            });
          });
        }

        initModal() {
          if (!this.modalManager.getModal('drawer-login')) {
            this.modalManager.register('drawer-login', {
              onOpen: (container) => {
                const $headerUserIcon = document.querySelector('.header__user-icon');
                if ($headerUserIcon) {
                  $headerUserIcon.setAttribute('data-show-modal', 'false');
                }
                if (this.container) {
                  return;
                }
                this.container = container;
                this.initLogin(container);
              },
              onClose: (container) => {
                this.status = false;
                this.changeType('login');
                // 清空asyncEmail
                this.asyncEmail = null;
                this.referralInviterCode = null;
                // 弹窗关闭时重置注册渠道来源
                this.source = 2;
                this.marketingCampaignId = null;
              },
            });
          }
          this.source = 2;
          this.modalManager.open('drawer-login');
        }
        // 导航中弹窗逻辑
        drawerInit() {
          this.$drawerLogin = $(this.querySelector('#drawer-login'))[0];
          this.$loginButton = $(this.querySelector('.header__icon-wrapper'))[0];

          customEventListener(this.$loginButton, 'click', this.initModal.bind(this));

          const $headerJoinUs = $(this.querySelector('.header-join-us'));
          $headerJoinUs.on('click', () => {
            this.initModal(false);
            setTimeout(() => {
              this.changeType('register');
            }, 0);
          });
        }

        changeType(type) {
          this.currentType = type;
          if (this.mobileType.has(type)) {
            // this.mobileType.delete(type);
          } else {
            this.mobileType.add(type);
          }
          this.resetFieldStatus();
          // 获取所有data-type的元素
          const $elements = $(this.container?.querySelectorAll('[data-header-type]'));
          const $drawerLogin = $(this.container?.querySelector('#drawer-login'));

          switch (type) {
            case 'login':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'login');
              $elements.filter('[data-header-type="login"]').removeClass('hidden');
              break;
            case 'register':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'register');
              $elements.filter('[data-header-type="register"]').removeClass('hidden');
              break;
            case 'forgot-password':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'forgot-password');
              $elements.filter('[data-header-type="forgot-password"]').removeClass('hidden');
              break;
            case 'reset-password':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'reset-password');
              $elements.filter('[data-header-type="reset-password"]').removeClass('hidden');
              break;
            case 'async-password':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'async-password');
              $elements.filter('[data-header-type="async-password"]').removeClass('hidden');
              break;
            case 'verify-success':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'verify-success');
              $elements.filter('[data-header-type="verify-success"]').removeClass('hidden');
              break;
            case 'verify':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'verify');
              $elements.filter('[data-header-type="verify"]').removeClass('hidden');
              this.countdown();
              break;
            case 'setup-password':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'setup-password');
              $elements.filter('[data-header-type="setup-password"]').removeClass('hidden');
              break;
            case 'sign-expired':
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'sign-expired');
              $elements.filter('[data-header-type="sign-expired"]').removeClass('hidden');
              break;
            default:
              $elements.addClass('hidden');
              $drawerLogin.attr('data-current-type', 'login');
              $elements.filter('[data-header-type="login"]').removeClass('hidden');
              break;
          }
        }

        // 倒计时
        countdown() {
          const $verifyPart = $(this.container.querySelector('[data-header-type="verify"]'));
          const $verifyStart = $verifyPart.find('.verify-code_start');
          $verifyStart.removeClass('hidden');
          const $countdown = $verifyStart.find('span');
          const $resend = $verifyPart.find('.verify-code_resend');
          $resend.addClass('hidden');
          let time = 60;
          $countdown.text(time);
          this.timer = setInterval(() => {
            time--;
            $countdown.text(time);
            if (time <= 0) {
              clearInterval(this.timer);
              this.timer = null;
              $verifyStart.addClass('hidden');
              $resend.removeClass('hidden');
            }
          }, 1000);
        }

        async fetchRsa() {
          const url = '/shopify/auth/rsa';
          const { data } = await window.litime.http.get(url);
          this.rsa = data.publicKey;
        }

        async login(data) {
          const url = '/shopify/auth/login';
          const res = await window.litime.http.post(url, {
            data: {
              ...data,
            },
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051106) {
            this.changeType('async-password');
            this.sign = res.data.sign;
            return res;
          } else if (res.code === 10051102) {
            throw new Error(window.i18n.error_message_10051102);
          } else if (res.code === 10051105) {
            throw new Error(window.i18n.error_message_10051105);
          } else if (res.code === 10051109) {
            throw new Error(window.i18n.error_message_10051109_login);
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        async register(data) {
          const url = '/shopify/auth/register';
          const res = await window.litime.http.post(url, {
            data: {
              ...data,
              source: this.source,
              referralInviterCode: this.referralInviterCode,
              ...(this.marketingCampaignId ? { marketingCampaignId: this.marketingCampaignId } : {}),
            },
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051404) {
            throw new Error(window.i18n.error_message_10051404);
          } else if (res.code === 10051109) {
            throw new Error(window.i18n.error_message_10051109);
          } else if (res.code === 10051424) {
            throw new Error(window.i18n.error_message_10051424);
          } else if (res.code === 10051425) {
            throw new Error(window.i18n.error_message_10051425);
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        async sendCode(data) {
          const url = '/shopify/auth/send-verification-code';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051410) {
            throw new Error(window.i18n.error_message_10051410);
          } else if (res.code === 10051404) {
            throw new Error(window.i18n.error_message_10051404);
          } else if (res.code === 10051409) {
            throw new Error(window.i18n.error_message_10051409);
          } else if (res.code === 10051109) {
            throw new Error(window.i18n.error_message_10051109_login);
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        async forgotPassword(data) {
          const url = '/shopify/auth/forget';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051109) {
            throw new Error(window.i18n.error_message_10051109);
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }
        // 校验sign
        async verifyForgetSign(data) {
          const url = '/shopify/auth/forget/check';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051107) {
            throw new Error(window.i18n.error_message_10051107);
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        async resetPassword(data) {
          const url = '/shopify/auth/reset';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            return res;
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        async asyncPassword(data) {
          const url = '/shopify/auth/login/security';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051107) {
            throw new Error(window.i18n.error_message_10051107);
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        // 校验sign
        async verifySetupSign(data) {
          const url = '/shopify/auth/invite/check';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051107) {
            throw new Error(window.i18n.error_message_10051107);
          } else if (res.code === 10051110) {
            return res;
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        async setupPassword(data) {
          const url = '/shopify/auth/invite';
          const res = await window.litime.http.post(url, {
            data,
          });
          if (res.code === 200) {
            return res;
          } else if (res.code === 10051110) {
            throw new Error(window.i18n.error_message_10051109);
          } else {
            throw new Error(window.i18n.request_failed);
          }
        }

        showButtonLoading(button) {
          button.attr('data-show-loading', true);
        }

        hideButtonLoading(button) {
          button.attr('data-show-loading', false);
        }

        validateField(field) {
          const $field = $(field);
          const value = $field.val();
          const name = $field.attr('name');
          let isValid = true;

          // 必填校验
          if ($field.prop('required') && !value) {
            isValid = false;
          }

          if (name === 'email' && value && !ltUtils.rule.email.test(value)) {
            isValid = false;
          }

          if (name === 'password' && value && !ltUtils.rule.password.test(value)) {
            isValid = false;
          }

          // 更新字段状态
          this.updateFieldStatus($field, isValid);
          return isValid;
        }

        updateFieldStatus($field, isValid) {
          const $inputTextContainer = $field.parents('.input_text_container');

          const $errorMessage = $inputTextContainer.siblings('.error-message');
          if (!isValid) {
            const name = $field.attr('name');
            const $dataTipFormat = $inputTextContainer.attr('data-tip-format');
            if (name === 'email' && $field.val() && !ltUtils.rule.email.test($field.val())) {
              $errorMessage.text($dataTipFormat);
              $inputTextContainer.attr('data-error', 'true');
            } else if (name === 'password' && $field.val() && !ltUtils.rule.password.test($field.val())) {
              $errorMessage.text($dataTipFormat);
              $inputTextContainer.attr('data-error', 'true');
            } else if (name === 'confirmPassword' && $field.val()) {
              $errorMessage.text($dataTipFormat);
              $inputTextContainer.attr('data-error', 'true');
            } else {
              $inputTextContainer.attr('data-error', 'true');
            }
          } else {
            $inputTextContainer.attr('data-error', 'false');
          }
        }

        resetFieldStatus() {
          const allInputError = $(this.container?.querySelectorAll('[data-error="true"]'));
          allInputError.each((_, field) => {
            $(field).attr('data-error', 'false');
          });
        }

        initLogin(container) {
          // 获取登录部分
          const $loginPart = $(container.querySelector('[data-header-type="login"]'));
          const $loginForgotPassword = $loginPart.find('.login-forgot-password');
          // 点击跳转到忘记密码事件
          $loginForgotPassword.on('click', () => {
            this.changeType('forgot-password');
          });
          // 点击跳转到注册事件
          const $loginCreateAccount = $loginPart.find('.login-create-account');
          $loginCreateAccount.find('.highlight').on('click', () => {
            this.changeType('register');
          });
          // pc端点击返回事件
          const $headerPcBack = $(container).find('.header-pc_back');
          $headerPcBack.on('click', () => {
            this.changeType('login');
          });
          // 获取login-submit
          const $loginSubmit = $loginPart.find('.submit-button').find('button');
          $loginSubmit.on('click', async (event) => {
            event.preventDefault();
            let isValid = true;
            $loginPart.find('[required]').each((_, field) => {
              if (!this.validateField(field)) {
                isValid = false;
              }
            });
            if (!isValid) {
              return;
            }
            if (this.status) {
              return;
            }
            this.status = true;
            this.showButtonLoading($loginSubmit);
            try {
              if (!this.rsa) {
                await this.fetchRsa();
              }
              // 获取$loginPart下的from表单参数
              const formData = new FormData($loginPart.find('form')[0]);
              const data = Object.fromEntries(formData);

              const encryptedPassword = window.litime.rsaEncryptWithCrypto(this.rsa, data.password);
              const urlParams = new URLSearchParams(window.location.search);
              let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
              if (redirectUrl === '/') {
                if (window.location.href.includes('/login')) {
                  redirectUrl = window.location.origin;
                } else {
                  redirectUrl = window.location.href;
                }
              } else {
                redirectUrl = window.location.origin + redirectUrl;
              }
              const res = await this.login({
                email: data.email,
                password: encryptedPassword,
                loginType: 1,
                returnTo: redirectUrl,
              });
              this.hideButtonLoading($loginSubmit);
              this.status = false;

              if (res.code === 200) {
                if (window.handleAuthCustomTrack) {
                  window.handleAuthCustomTrack('login', 'success');
                }
                this.hideButtonLoading($loginSubmit);
                this.modalManager.close('drawer-login');
                window.litime.setLocalStorage('ltUserInfo', res.data);
                window.litime.setLocalStorage('ltToken', res.data.token);

                window.litime.showToast('success', window.i18n.login_success);
                // 刷新页面
                window.location.href = res.data.mutilpass;
              }
            } catch (error) {
              if (window.handleAuthCustomTrack) {
                window.handleAuthCustomTrack('login', 'fail');
              }
              this.hideButtonLoading($loginSubmit);
              this.status = false;
              window.litime.showToast('error', error.message);
            }
          });

          // 移动端返回事件
          const $mobileBack = $(container).find('.header-mobile_back');
          $mobileBack.on('click', () => {
            // this.changeType('login');

            if (this.currentType === 'login') {
              this.modalManager.close('drawer-login');
              this.mobileType.clear();
            } else if (this.mobileType.size === 0) {
              this.modalManager.close('drawer-login');
              this.mobileType.clear();
            } else if (this.mobileType.size === 1) {
              this.changeType('login');
              this.mobileType.clear();
            } else {
              // 转换为数组
              const arr = Array.from(this.mobileType);
              const last = arr[arr.length - 1];
              // 删除最后一个元素
              if (arr.length > 0) {
                this.mobileType.delete(last);
              }
              this.changeType(arr[arr.length - 2]);
            }
          });

          // 获取create-account
          const privacy_policy = $loginPart.find('.create-account').find('.highlight')[0];
          $(privacy_policy).on('click', () => {
            window.open('/policies/privacy-policy', '_blank');
          });
          const terms_of_use = $loginPart.find('.create-account').find('.highlight')[1];
          $(terms_of_use).on('click', () => {
            window.open('/pages/terms-conditions', '_blank');
          });

          // 注册
          this.initRegister(container);

          // 忘记密码
          this.initForgotPassword(container);

          // 验证成功
          this.initVerifySuccess(container);

          // 验证
          this.initVerify(container);

          // 重置密码
          this.initResetPassword(container);

          // 同步密码
          this.initAsyncPassword(container);

          // 设置密码
          this.initSetupPassword(container);
        }

        initRegister(container) {
          const $registerPart = $(container.querySelector('[data-header-type="register"]'));
          const $registerSubmit = $registerPart.find('.submit-button').find('button');
          // 绑定发送注册验证码事件
          $registerSubmit.on('click', async (event) => {
            event.preventDefault();
            let isValid = true;
            $registerPart.find('[required]').each((_, field) => {
              if (!this.validateField(field)) {
                isValid = false;
              }
            });
            if (!isValid) {
              return;
            }
            if (this.status) {
              return;
            }
            this.status = true;
            this.showButtonLoading($registerSubmit);
            try {
              if (!this.rsa) {
                await this.fetchRsa();
              }
              // 获取$registerPart下的from表单参数
              const formData = new FormData($registerPart.find('form')[0]);
              const data = Object.fromEntries(formData);
              const urlParams = new URLSearchParams(window.location.search);
              let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
              if (redirectUrl === '/') {
                if (window.location.href.includes('/register')) {
                  redirectUrl = window.location.origin;
                } else {
                  redirectUrl = window.location.href;
                }
              } else {
                redirectUrl = window.location.origin + redirectUrl;
              }
              const res = await this.register({
                email: data.email,
                password: window.litime.rsaEncryptWithCrypto(this.rsa, data.password),
                acceptsMarketing: data.acceptsMarketing ? 1 : 0,
                returnTo: redirectUrl,
              });
              this.status = false;
              if (res.code === 200) {
                if (window.handleAuthCustomTrack) {
                  window.handleAuthCustomTrack('register', 'success');
                }
                this.hideButtonLoading($registerSubmit);
                window.litime.showToast('success', window.i18n.register_success);
                if (res.data?.referralInvitedReward) {
                  window.litime.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                }
                this.modalManager.close('drawer-login');
                window.litime.setLocalStorage('ltUserInfo', res.data);
                window.litime.setLocalStorage('ltToken', res.data.token);

                window.location.href = res.data.mutilpass;
              }
            } catch (error) {
              if (window.handleAuthCustomTrack) {
                window.handleAuthCustomTrack('register', 'fail');
              }
              this.hideButtonLoading($registerSubmit);
              this.status = false;
              window.litime.showToast('error', error.message);
            }
          });
          const $registerBackToLogin = $registerPart.find('.back-to-login');
          $registerBackToLogin.find('.highlight').on('click', () => {
            this.changeType('login');
          });

          // 获取create-account
          const privacy_policy = $registerPart.find('.create-account').find('.highlight')[0];
          $(privacy_policy).on('click', () => {
            window.open('/policies/privacy-policy', '_blank');
          });
          const terms_of_use = $registerPart.find('.create-account').find('.highlight')[1];
          $(terms_of_use).on('click', () => {
            window.open('/pages/terms-conditions', '_blank');
          });
        }

        initForgotPassword(container) {
          const _this = this;
          const $forgotPasswordPart = $(container.querySelector('[data-header-type="forgot-password"]'));
          const $forgotPasswordSubmit = $forgotPasswordPart.find('.submit-button').find('button');
          $forgotPasswordSubmit.on('click', async function (event) {
            event.preventDefault();
            // 获取$forgotPasswordPart下的input值
            const $forgotPasswordInput = $forgotPasswordPart.find('input');
            const isValid = _this.validateField($forgotPasswordInput);
            if (!isValid) {
              return;
            }
            if (_this.status) {
              return;
            }
            _this.status = true;
            _this.showButtonLoading($forgotPasswordSubmit);
            try {
              const res = await _this.sendCode({
                email: $forgotPasswordInput.val(),
                type: 2,
              });
              if (res.code === 200) {
                _this.hideButtonLoading($forgotPasswordSubmit);
                _this.changeType('verify-success');
                const $verifySuccessPart = $(container.querySelector('[data-header-type="verify-success"]'));
                const $verifySuccessDescription = $verifySuccessPart.find('.verify-success-description');
                const description = $verifySuccessDescription.text();
                const emailHighlight = `<span class="text-primary">${$forgotPasswordInput.val()}</span>`;
                // 找到description中的{{email}}，并替换为$forgotPasswordInput.val()
                const newDescription = description
                  .replace('{{email}}', emailHighlight)
                  .replace('{{ email }}', emailHighlight);
                $verifySuccessDescription.html(newDescription);
                window.litime.showToast('success', window.i18n.email_send_success);
              }
              _this.status = false;
            } catch (error) {
              _this.hideButtonLoading($forgotPasswordSubmit);
              _this.status = false;
              window.litime.showToast('error', error.message);
            }
          });
        }

        initVerify(container) {
          const $verifyPart = $(container.querySelector('[data-header-type="verify"]'));
          const $resend = $verifyPart.find('.verify-code_resend');
          const $verifyStart = $verifyPart.find('.verify-code_start');
          // 绑定重新发送验证码事件
          $resend.on('click', async () => {
            // 获取$registerPart下的from表单参数
            const $registerPart = $(container.querySelector('[data-header-type="register"]'));
            const formData = new FormData($registerPart.find('form')[0]);
            const data = Object.fromEntries(formData);
            clearInterval(this.timer);
            $verifyStart.removeClass('hidden');
            $resend.addClass('hidden');
            this.countdown();
            try {
              const res = await this.sendCode({
                email: data.email,
                type: 1,
              });
              if (res.code === 200) {
                window.litime.showToast('success', window.i18n.send_code_success);
              }
            } catch (error) {
              window.litime.showToast('error', error.message);
            }
          });
          // 绑定注册账号事件
          const $verifySubmit = $verifyPart.find('.submit-button').find('button');
          $verifySubmit.on('click', async (event) => {
            event.preventDefault();
            const $registerPart = $(container.querySelector('[data-header-type="register"]'));
            const formData = new FormData($registerPart.find('form')[0]);
            const data = Object.fromEntries(formData);
            const verify = $verifyPart.find('input').val();
            const isValid = this.validateField($verifyPart.find('input'));
            if (!isValid) {
              return;
            }
            if (this.status) {
              return;
            }
            this.status = true;
            this.showButtonLoading($verifySubmit);
            try {
              if (!this.rsa) {
                await this.fetchRsa();
              }
              const encryptedPassword = window.litime.rsaEncryptWithCrypto(this.rsa, data.password);
              const res = await this.register({
                ...data,
                verificationCode: verify,
                password: encryptedPassword,
                acceptsMarketing: acceptsMarketing ? 1 : 0,
              });
              if (res.code === 200) {
                this.changeType('login');
                this.hideButtonLoading($verifySubmit);
                window.litime.showToast('success', window.i18n.register_success);
              }
              this.status = false;
            } catch (error) {
              this.hideButtonLoading($verifySubmit);
              this.status = false;
              window.litime.showToast('error', error.message);
            }
          });

          const $verifyHelpText = $verifyPart.find('.verify-help-text');
          $verifyHelpText.on('click', () => {
            window.litime.openChatApp();
          });
        }

        initVerifySuccess(container) {
          const $verifySuccessPart = $(container.querySelector('[data-header-type="verify-success"]'));
          const $verifySuccessSubmit = $verifySuccessPart.find('.login-back');
          $verifySuccessSubmit.on('click', () => {
            this.changeType('login');
          });
          const $checkEmail = $verifySuccessPart.find('.check_email').find('.highlight');
          $checkEmail.on('click', () => {
            window.litime.openChatApp();
          });
        }

        initResetPassword(container) {
          const $resetPasswordPart = $(container.querySelector('[data-header-type="reset-password"]'));
          const $resetPasswordSubmit = $resetPasswordPart.find('.submit-button').find('button');

          $resetPasswordSubmit.on('click', async (event) => {
            event.preventDefault();
            const $resetPasswordForm = $resetPasswordPart.find('form');
            const formData = new FormData($resetPasswordForm[0]);
            const data = Object.fromEntries(formData);
            let isValid = true;
            $resetPasswordForm.find('[required]').each((_, field) => {
              if (!this.validateField(field)) {
                isValid = false;
              }
            });
            if (!isValid) {
              return;
            }
            if (data.password !== data.confirmPassword) {
              this.updateFieldStatus($resetPasswordForm.find('input[name="confirmPassword"]'), false);
              return;
            }
            if (this.status) {
              return;
            }
            this.status = true;
            this.showButtonLoading($resetPasswordSubmit);
            if (!this.rsa) {
              await this.fetchRsa();
            }
            const password = window.litime.rsaEncryptWithCrypto(this.rsa, data.password);
            const confirmPassword = window.litime.rsaEncryptWithCrypto(this.rsa, data.confirmPassword);
            if (this.urlParams.get('type') === 'reset') {
              try {
                const signRes = await this.verifyForgetSign({
                  email: this.urlParams.get('email'),
                  sign: this.urlParams.get('sign'),
                });
                const res = await this.forgotPassword({
                  password,
                  confirmPassword,
                  email: this.urlParams.get('email'),
                  sign: this.urlParams.get('sign'),
                });
                if (res.code === 200) {
                  this.modalManager.close('drawer-login');
                  window.litime.showToast('success', window.i18n.reset_password_success);
                  window.litime.setLocalStorage('ltUserInfo', res.data);
                  window.litime.setLocalStorage('ltToken', res.data.token);
                  window.location.href = res.data.mutilpass;
                }
                this.status = false;
                this.hideButtonLoading($resetPasswordSubmit);
              } catch (error) {
                this.status = false;
                this.hideButtonLoading($resetPasswordSubmit);
                window.litime.showToast('error', error.message);
              }
            } else {
              try {
                const res = await this.resetPassword({
                  password,
                  confirmPassword,
                });
                if (res.code === 200) {
                  this.modalManager.close('drawer-login');
                  window.litime.setLocalStorage('ltUserInfo', res.data);
                  window.litime.setLocalStorage('ltToken', res.data.token);

                  this.hideButtonLoading($resetPasswordSubmit);
                  window.litime.showToast('success', window.i18n.reset_password_success);
                  window.location.href = res.data.mutilpass;
                }
                this.status = false;
              } catch (error) {
                this.status = false;
                this.hideButtonLoading($resetPasswordSubmit);
                window.litime.showToast('error', error.message);
              }
            }
          });
        }

        initAsyncPassword(container) {
          const $asyncPasswordPart = $(container.querySelector('[data-header-type="async-password"]'));
          const $asyncPasswordSubmit = $asyncPasswordPart.find('.submit-button').find('button');
          $asyncPasswordSubmit.on('click', async (event) => {
            event.preventDefault();
            let isValid = true;
            $asyncPasswordPart.find('[required]').each((_, field) => {
              if (!this.validateField(field)) {
                isValid = false;
              }
            });
            if (!isValid) {
              return;
            }
            const $asyncPasswordForm = $asyncPasswordPart.find('form');
            const formData = new FormData($asyncPasswordForm[0]);
            const data = Object.fromEntries(formData);
            if (data.password !== data.confirmPassword) {
              this.updateFieldStatus($asyncPasswordForm.find('input[name="confirmPassword"]'), false);
              return;
            }
            try {
              const $loginPart = $(container.querySelector('[data-header-type="login"]'));
              const $loginEmail = $loginPart.find('input[name="email"]');
              const email = $loginEmail.val();
              if (this.status) {
                return;
              }
              this.status = true;
              this.showButtonLoading($asyncPasswordSubmit);
              const urlParams = new URLSearchParams(window.location.search);
              let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
              if (redirectUrl === '/') {
                if (window.location.href.includes('/login')) {
                  redirectUrl = window.location.origin;
                } else {
                  redirectUrl = window.location.href;
                }
              } else {
                redirectUrl = window.location.origin + redirectUrl;
              }
              const res = await this.asyncPassword({
                email: email || this.asyncEmail,
                password: window.litime.rsaEncryptWithCrypto(this.rsa, data.password),
                confirmPassword: window.litime.rsaEncryptWithCrypto(this.rsa, data.confirmPassword),
                sign: this.sign,
                returnTo: redirectUrl,
              });
              if (res.code === 200) {
                this.modalManager.close('drawer-login');
                window.litime.setLocalStorage('ltUserInfo', res.data);
                window.litime.setLocalStorage('ltToken', res.data.token);

                window.litime.showToast('success', window.i18n.async_password_success);
                window.location.href = res.data.mutilpass;
              }
              this.status = false;
            } catch (error) {
              this.status = false;
              this.hideButtonLoading($asyncPasswordSubmit);
              window.litime.showToast('error', error.message);
            }
          });
        }

        initSetupPassword(container) {
          const $setupPasswordPart = $(container.querySelector('[data-header-type="setup-password"]'));
          const $setupPasswordSubmit = $setupPasswordPart.find('.submit-button').find('button');
          $setupPasswordSubmit.on('click', async (event) => {
            event.preventDefault();
            let isValid = true;
            $setupPasswordPart.find('[required]').each((_, field) => {
              if (!this.validateField(field)) {
                isValid = false;
              }
            });
            if (!isValid) {
              return;
            }
            const $setupPasswordForm = $setupPasswordPart.find('form');
            const formData = new FormData($setupPasswordForm[0]);
            const data = Object.fromEntries(formData);
            if (data.password !== data.confirmPassword) {
              this.updateFieldStatus($setupPasswordForm.find('input[name="confirmPassword"]'), false);
              return;
            }
            try {
              if (this.status) {
                return;
              }
              this.status = true;
              this.showButtonLoading($setupPasswordSubmit);
              if (!this.rsa) {
                await this.fetchRsa();
              }
              const res = await this.setupPassword({
                email: this.urlParams.get('email'),
                password: window.litime.rsaEncryptWithCrypto(this.rsa, data.password),
                confirmPassword: window.litime.rsaEncryptWithCrypto(this.rsa, data.confirmPassword),
                sign: this.urlParams.get('sign'),
              });
              if (res.code === 200) {
                this.modalManager.close('drawer-login');
                window.litime.setLocalStorage('ltUserInfo', res.data);
                window.litime.setLocalStorage('ltToken', res.data.token);
                window.litime.showToast('success', window.i18n.setup_password_success);
                window.location.href = res.data.mutilpass;
              }
              this.hideButtonLoading($setupPasswordSubmit);

              this.status = false;
            } catch (error) {
              this.status = false;
              this.hideButtonLoading($setupPasswordSubmit);
              window.litime.showToast('error', error.message);
            }
          });
        }
      },
    );
  }
});
